import { inject, observer } from "mobx-react";

import Default from "./Default";

const SelectFilialUI = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        let Specified = Default;

        for (const key in abTests) {
            const ver = init?.data?._ab_m?.[key]?._d?.colorHeader;
            if (ver === "v2") {
                Specified = abTests[key];
                break;
            }
        }

        return <Specified {...props} />;
    }),
);

const abTests = {};

export default SelectFilialUI;
